export default __webpack_public_path__ + "static/media/Isotext-Pro-Regular.14d744d2.ttf";